"use client";

import React from "react";
import { Users, Heart, ClipboardCheck, Flame, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "Friendship",
  description: "Offering consistent human presence to reduce isolation and bring joy to daily life.",
  icon: Users
}, {
  title: "Prayer",
  description: "Lifting up our seniors in faith, providing comfort through shared devotion.",
  icon: Heart
}, {
  title: "Basic Needs",
  description: "Conducting gentle welfare checks to ensure safety, health, and peace of mind.",
  icon: ClipboardCheck
}, {
  title: "Spiritual Support",
  description: "Nurturing the soul with compassionate conversation and Orthodox Christian love.",
  icon: Flame
}];
export default function ThePillarsOfOurCare() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-pillars-of-our-care" className="w-full py-20 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4 tracking-tight" style={{
          fontFamily: '"Montserrat", sans-serif'
        }}>
            The Pillars of Our Care
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">
            Guided by faith and compassion, our ministry is built upon four essential pillars designed to bring dignity and comfort to seniors in their own homes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={pillar.title} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full border-none shadow-sm hover:shadow-md transition-all duration-300 hover:bg-secondary/10 group bg-card">
                  <CardHeader className="text-center pb-2 pt-8">
                    <div className="w-20 h-20 mx-auto rounded-full bg-primary/5 flex items-center justify-center mb-6 group-hover:bg-primary/10 transition-colors duration-300 group-hover:scale-110 transform">
                      <Icon className="w-10 h-10 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl text-primary" style={{
                  fontFamily: '"Montserrat", sans-serif'
                }}>
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center pb-8">
                    <p className="text-muted-foreground leading-relaxed">
                      {pillar.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className={`mt-16 text-center transition-all duration-1000 delay-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="rounded-full px-8">
            <Link to="/VolunteerSignUpPage">
              Join Our Volunteer Network
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}